export const sanitizeLettersNumbersAndSpacialChars = (
  event: React.ChangeEvent<HTMLInputElement>,
  maxLength?: number,
  regex?: RegExp
) => {
  event.target.value = event.target.value
    .replace(regex || /[^a-zA-Z0-9\u05D0-\u05EA|(()())'".?! ,]/g, '')
    .slice(
      0,
      Math.min(
        event.target.value.length,
        maxLength || event.target.value.length
      )
    );
};
